import React from 'react';
import styled from 'styled-components';
import { Body } from '@vds/typography';
import PropTypes from 'prop-types';

export const AccessoryTileWrapper = styled.div`
  margin-bottom: 20px;
  margin-left: 20px !important;
  padding-top: 20px !important;
`;

export default AccessoryTileWrapper;

const BodyWrapper = styled.div`
  ${({ styles }) => styles}
`;

export const FontWrapper = (props) => {
  const styles = `>${props.primitive} { ${props.styles} }`;
  return (
    <BodyWrapper styles={styles}>
      <Body primitive={props.primitive} size={props.size}>
        {props.children}
      </Body>
    </BodyWrapper>
  );
};

FontWrapper.propTypes = {
  primitive: PropTypes.string,
  styles: PropTypes.string,
  children: PropTypes.any,
  size: PropTypes.string,
};
